<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title class="white--text"
              >Policies Setting</v-toolbar-title
            >
            <v-spacer />
          </v-toolbar>

          <v-card-text>
            <v-layout wrap row>
              <v-flex md6 :key="p" v-for="p in policies">
                <v-card>
                  <v-card-title>
                    {{ p }}
                  </v-card-title>
                  <v-card-text>
                    <vue-editor
                      v-model="policiesContent[p]"
                      @text-change="save(p)"
                    ></vue-editor>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { VueEditor } from 'vue2-editor';
import api from '../../api';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      policies: [
        'privacy',
        'refund',
        'cancel',
        'shipping',
        'terms',
        'return',
        'about',
      ],
      policiesContent: {
        privacy: '',
        refund: '',
        cancel: '',
        shipping: '',
        terms: '',
        return: '',
        about: '',
      },
    };
  },
  watch: {
    vid() {
      if (this.vid) this.policies.forEach(p => this.load(p));
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  created() {
    if (this.vid) this.policies.forEach(p => this.load(p));
  },
  methods: {
    load(p) {
      api.get('vendors/policies/' + p).then(r => {
        this.policiesContent[p] = r.data.policy;
      });
    },
    save(type) {
      debounce(() => this.update(type), 1000);
    },
    update(type) {
      api
        .post('vendors/policies/' + type, {
          policy: this.policiesContent[type],
        })
        .then(r => {
          this.policiesContent[type] = r.data.policy;
        });
    },
  },
};
const debounce = (() => {
  let debounceTimer;
  return (func, delay) => {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context), delay);
  };
})();
</script>
